import { Button, Text, Box, Input } from "@chakra-ui/react"
import WithAuth from "../components/hoc/with-auth"
import { AuthLayout } from "../components/layouts"
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx"
import DealsPage from "../components/pages/deals-page"

const Deals = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar pageTitle="Deals" pageDesc="List of all the deals">
          <DealsPage />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  )
}

export default Deals
